import '@app/shared/components/ArchiveLabel/styles/ArchiveLabel.desktop.scss';

export const ArchiveLabel = () => <div className="archive-tab">В архиве</div>;
